const imageLimits = {
  width: 1000, // in pixels
  size: 5, // in MB
};

export const getImageScalesOnUpload = (image) => {
  const imageObject = new Image();
  imageObject.src = URL.createObjectURL(image);

  const loadImage = new Promise((resolve) => {
    imageObject.onload = () => {
      const { height, width } = imageObject;
      resolve({ height, width });
    };
  });

  return loadImage;
};

export const convertByteToMb = (bytes) => (bytes * 0.000001).toFixed(1);

export const validateImageSizeOnUpload = async (img) => {
  const scales = await getImageScalesOnUpload(img);
  const scaleLimit = imageLimits.width;
  const imageSize = +convertByteToMb(img.size);

  if (!scales.width || !img.size) {
    return { isValid: false, message: 'Something went wrong' };
  }
  if (scales.width < scaleLimit) {
    return {
      isValid: false,
      message: `Image must be at least ${scaleLimit} pixels`,
      translationKey: 'image_minimum_width_error',
      limit: scaleLimit,
    };
  }
  if (imageSize > imageLimits.size) {
    return {
      isValid: false,
      message: `Image must be less than ${imageLimits.size} MB`,
      translationKey: 'image_maximum_size_error',
      limit: imageLimits.size,
    };
  }

  return { isValid: true, message: '', translationKey: '', limit: null };
};
